import React, { useEffect, useRef, useState } from "react";
import "./Project.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdNotificationsNone, MdOutlineDelete } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import {
  deleteProject,
  getAddNewTaskDetail,
  getOnGoingTask,
  getOverDueTask,
  getUnderReviewTask,
  getUpComingTask,
  listOfProject,
  removeTask,
} from "../../../apiCall";
import Select from 'react-select'

import { CgAttachment } from "react-icons/cg";
import toast from "react-hot-toast";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStateValue } from "../../../StateProvider";
import { isAdmin } from "../../../utils/adminAccess";
import {
  getClassNamesOfEndDate,
  getClassNamesOfStartDate,
  getClassNamesOfStatus,
} from "../../../utils/colorCode";
import { IoMdSearch } from "react-icons/io";
import { formatDateTimetoAmPm } from "../../../utils/FormateDate";
import { convertToUserOptions, customStyles } from "../../../utils/ConvertToOptions";


function formatTimeDuration(duration) {
  const parts = duration.split(" "); // Split the input string by space
  let days = 0,
    time = "00:00";

  // Extract days and time from the input string
  if (parts.length > 2) {
    days = parseInt(parts[0]);
    time = parts[2];
  } else if (parts.length === 1) {
    if (parts[0].includes(":")) {
      time = parts[0];
    } else {
      days = parseInt(parts[0]);
    }
  }

  // Split time into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Construct the output based on the specified conditions
  if (days === 0 && hours === 0 && minutes === 0) {
    return "0 days 00:00";
  } else if (days === 0) {
    return ` ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
      } `;
  } else if (hours === 0 && minutes === 0) {
    return ` ${days} ${days === 1 ? "day" : "days"} `;
  } else {
    return ` ${days} ${days === 1 ? "day" : "days"} ${hours < 10 ? "0" + hours : hours
      }:${minutes < 10 ? "0" + minutes : minutes} `;
  }
}

const Project = () => {
  const [searchParams] = useSearchParams();
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();
  const userFilterParams = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const statusFilterParams = searchParams.get("project_status_filter");
  const searchFilterParams = searchParams.get("project_search_filter");
  const projectType = searchParams.get("project_type");
  const userCode = searchParams.get("user_code");

  const projectId = searchParams.get("project_id");
  const navigate = useNavigate();
  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };

  const removeProject = async (id) => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });

    try {
      const response = await deleteProject(id);
      if (response?.status === 200) {
        toast.success(response.data.status);
        refetch();
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [isStatusFilter, setIsStatusFilter] = useState(projectType ? "" : "2");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const searchInputWeb = useRef(null);
  const searchInputMobile = useRef(null);
  const [taskStatusFilter, setTaskStatusFilter] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const fetchProjectList = async (userFilter) => {
    // Perform the API call to fetch company info
    let response;
    dispatch({ type: "SET_LOADING", status: true });

    try {
      if (projectType === "over_due") {
        response = await getOverDueTask(userCode, userInfo.user_code);
      } else if (projectType === "on_going") {
        response = await getOnGoingTask(userCode, userInfo.user_code);
      } else if (projectType === "under_review") {
        response = await getUnderReviewTask(userCode, userInfo.user_code);
      } else if (projectType === "up_coming") {
        response = await getUpComingTask(userCode, userInfo.user_code);
      } else {
        response = await listOfProject(userFilter);
      }
      if (response?.status === 200) {
        // setProjectList([])
        // setFilteredData([])
        // setTimeout(() => {
        setProjectList(response.data.data);
        setFilteredData(response.data.data);

        // }, 500);
        // setTaskStatusFilter(transformedArray(response.data.task_status_list));
        // refetch();
      } else if (response?.response?.status) {
        toast.error("Something went wrong.");

      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
    return response?.data?.data || [];

  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["project-list", userFilter],
    queryFn: () => fetchProjectList(userFilter),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    // if(projectType){

    // }
    filterData(searchQuery, userFilter, isStatusFilter);
    setCurrentPage(1);
  }, [searchQuery, userFilter, isStatusFilter]);

  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
  }, [currentPage, filteredData]);

  useEffect(() => {
    filterData(searchQuery, userFilter, isStatusFilter);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );

    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [projectList]);

  useEffect(() => {
    if (projectId && filteredData.length > 0) {
      const targetIndex = filteredData.findIndex(
        (item) => item.ID === parseInt(projectId)
      );
      if (targetIndex !== -1) {
        const pageNumber =
          Math.floor(
            targetIndex / Number(sysConfig["Rows in MultiLine List"])
          ) + 1;
        setCurrentPage(pageNumber);
        // setCurrentItems(
        //   filteredData.slice(targetIndex, targetIndex + Number(sysConfig["Rows in MultiLine List"]))
        // );
      }
    }
  }, [projectId, filteredData]);

  const setDefaultValue = () => { };

  const handleUserChange = (option) => {
    removeSelection();
    const type = option.value;
    setUserFilter(type);
    // refetch();

    // setDefaultValue();
  };

  const handleIsStatusChange = (e) => {
    setIsStatusFilter(e.target.value);
    removeSelection();
    refetch();

    // setDefaultValue();
  };
  const handleSearch = () => {
    removeSelection();

    let query
    if (window.innerWidth >= 767) {

      query = searchInputWeb.current.value.toLowerCase();
    }
    else {
      query = searchInputMobile.current.value.toLowerCase();

    }
    setSearchQuery(query);
    refetch();

    // setDefaultValue();
  };
  const filterData = (query, user, status) => {
    let filtered = projectList;
    console.log("dfdfd", query, searchQuery)

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Name.toLowerCase().includes(query) ||
          item.Dscr.toLowerCase().includes(query)
      );
    }

    if (user && user !== "All") {
      filtered = filtered.filter(
        (item) => item.ProjLead === user ||
          item.AllocBy === user ||
          item?.tasks_list.some(task => (task.TaskLead === user || task.AllocBy === user))
      );
    }

    if (status) {
      filtered = filtered.filter(
        (item) => item?.Status?.idx === parseInt(status)
      );
    }
    if ((buttonRef.current && isFilterOpen && filtered.length > 0)) {
      buttonRef.current.click();
    }
    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setDefaultValue();
  };

  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);
  // ********************************************** get data start ****************************************************
  const {
    isLoading: isUserListLoading,
    data: useList,
    refetch: userListreFetch,
  } = useQuery({
    queryKey: ["new-project-form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail();
        if (response?.status === 200) {
          setUserList(response.data.data.users_list);
          setTaskStatusFilter(transformedArray(response.data.data.status_list));
        } else if (response?.response) {
          toast.error(response?.response?.data?.status);
        }
        dispatch({ type: "SET_LOADING", status: false });

        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
        throw error;
      }
    },
    // enabled: isAdmin(userInfo) ? true : false,
  });
  const [userList, setUserList] = useState(
    data?.status === 200 ? data.data.data.users_list : []
  );

  // ************************************************************* reset password modal **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const [changeUserFilter, setChangeUserFilter] = useState(true);

  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  const removeSelection = () => {
    if (!projectType) {
      navigate(`/project`);

      setChangeUserFilter(false);
    }
  };

  useEffect(() => {
    if (!projectType) {
      if (!projectId && changeUserFilter) {
        if (isAdmin(userInfo)) {
          setUserFilter(userInfo?.user_code);
        }
      } else {
        if (userInfo?.user_type === "Admin") {
          setUserFilter(userInfo?.user_code);
        }
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (userFilterParams) {
      if (userFilterParams !== "All") {
        const type = userFilterParams;
        setUserFilter(type);
        setDefaultValue();
      } else {
        setUserFilter("");
      }
    }

    if (statusFilterParams) {
      if (statusFilterParams !== "All") {
        setIsStatusFilter(statusFilterParams);
        setDefaultValue();
      } else {
        setIsStatusFilter("");
      }
    }
    if (searchFilterParams) {
      const query = searchFilterParams.toLowerCase();
      if (window.innerWidth >= 767) {
        searchInputWeb.current.value = query;
      }
      else {
        searchInputMobile.current.value = query;
      }
      setSearchQuery(query);
    }
  }, [userFilterParams, statusFilterParams, searchFilterParams]);

  const addNewProject = () => {
    console.log(isStatusFilter, userFilter);
    navigate(
      `/add/project?project_status_filter=${isStatusFilter}&project_user_filter=${userFilter}&project_search_filter=${encodeURIComponent(searchQuery)}`
    );

  };

  const editTask = (task) => {
    navigate(
      `/update/project/${task.ID}?project_status_filter=${isStatusFilter}&project_user_filter=${userFilter}&project_search_filter=${encodeURIComponent(searchQuery)}`
    );

  };

  // ****************************************** accordion start *********************************************
  const statusTitle = (status, projectType) => {
    if (projectType === "over_due") {
      return "List of Over due Project";
    } else if (status === "1" || projectType === "up_coming") {
      return "List of Up Coming Project";
    } else if (status === "2" || projectType === "on_going") {
      return "List of On Going Project";
    } else if (status === "3" || projectType === "under_review") {
      return "List of Under Review Project";
    } else if (status === "4") {
      return "List of Completed Project";
    } else if (status === "5") {
      return "List of Cancelled Project";
    } else {
      return "List of Project";
    }
  };
  const [isFilterOpen, setIsFilterOpend] = useState(true)
  const collapseRef = useRef(null);
  const buttonRef = useRef(null);


  useEffect(() => {
    // Ensure the ref points to the correct element
    const collapseElement = collapseRef.current;

    // Event listener for when the accordion is opened
    const handleShown = () => {
      console.log('Accordion is opened');
      setIsFilterOpend(true)
    };

    // Event listener for when the accordion is closed
    const handleHidden = () => {
      setIsFilterOpend(false)

      console.log('Accordion is closed');
    };

    // Attach event listeners for Bootstrap collapse events
    collapseElement.addEventListener('shown.bs.collapse', handleShown);
    collapseElement.addEventListener('hidden.bs.collapse', handleHidden);

    // Cleanup listeners when component unmounts
    return () => {
      collapseElement.removeEventListener('shown.bs.collapse', handleShown);
      collapseElement.removeEventListener('hidden.bs.collapse', handleHidden);
    };
  }, []);
  // ****************************************** accordion end *********************************************

  // ****************************************** accordion close when click outside start *********************************************
  const handleClickOutside = (event) => {
    if (collapseRef.current && !collapseRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      const collapseInstance = new window.bootstrap.Collapse(collapseRef.current, {
        toggle: false
      });
      collapseInstance.hide();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // ****************************************** accordion close when click outside end *********************************************
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area">
        <div className="container-fluid">
          <div className="row web-view">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              <div className="mb-5">
                <h3 className="mb-0 ">
                  {statusTitle(isStatusFilter, projectType)}
                </h3>
              </div>
            </div>
          </div>
          <div>

            {/* row */}
            <div className="row">
              <div className="col-12">
                {/* card */}
                <div className="card mb-4">
                  <div className="accordion position-absolute w-100 z-3 mobile-view" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header bg-white" id="headingOne">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" ref={buttonRef}
                          data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          <strong>

                            {statusTitle(isStatusFilter, projectType)}
                          </strong>
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" ref={collapseRef}
                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">

                        <div className="card-header  ">
                          <div className="row ">
                            {isAdmin(userInfo) && (
                              <div className=" mb-3 d-flex justify-content-end">
                                <div
                                  className="btn btn-primary   col-lg-2 col-md-4 col-12  "
                                  onClick={() => addNewProject()}
                                >
                                  + Add Project
                                </div>
                              </div>
                            )}
                          </div>
                          <>
                            <div className="row justify-content-between">
                              <div className=" col-lg-4 col-md-6 mt-md-3 d-flex">
                                <input
                                  ref={searchInputMobile}
                                  type="search"
                                  className="form-control "
                                  // value={searchQuery}
                                  // onChange={(e) => {
                                  //   if (e.target.value === "") {
                                  //     handleSearch();
                                  //   }
                                  // }}
                                  placeholder="Search for Name & Description."
                                />
                                <div
                                  className="btn btn-primary ms-3"
                                  onClick={() => handleSearch()}
                                >
                                  <IoMdSearch size={25} />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                {isAdmin(userInfo) && !projectType && (
                                  // <select
                                  //   className="form-select"
                                  //   aria-label="Default select example"
                                  //   value={userFilter}
                                  //   onChange={handleUserChange}
                                  // >
                                  //   <option disabled>Select User</option>
                                  //   <option selected="" value={""}>
                                  //     All
                                  //   </option>

                                  //   {userList.map((item) => (
                                  //     <option value={item}>{item}</option>
                                  //   ))}
                                  // </select>
                                  <Select
                                    // className="form-select"
                                    styles={customStyles}
                                    value={userFilter ? { label: userFilter, value: userFilter } : { label: "All", value: "All" }}

                                    placeholder="Select user."
                                    onChange={handleUserChange}

                                    options={[{ label: "Select a user", value: "Select a user", isDisabled: true }, { label: "All", value: "All" }, ...convertToUserOptions(userList)]}
                                  />
                                )}
                              </div>
                              <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                                {!projectType && (
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={isStatusFilter}
                                    onChange={handleIsStatusChange}
                                  >
                                    <option disabled>Select Status</option>
                                    <option selected="" value={""}>
                                      All
                                    </option>
                                    {taskStatusFilter.map((item) => (
                                      <option value={item.id}>{item.value}</option>
                                    ))}
                                  </select>
                                )}
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-header web-view  ">
                    <div className="row ">
                      {isAdmin(userInfo) && (
                        <div className=" mb-3 d-flex justify-content-end">
                          <div
                            className="btn btn-primary   col-lg-2 col-md-4 col-12  "
                            onClick={() => addNewProject()}
                          >
                            + Add Project
                          </div>
                        </div>
                      )}
                    </div>
                    <>
                      <div className="row justify-content-between">
                        <div className=" col-lg-4 col-md-6 mt-md-3 d-flex">
                          <input
                            ref={searchInputWeb}
                            type="search"
                            className="form-control "
                            // value={searchQuery}
                            onChange={(e) => {
                              if (e.target.value === "") {
                                handleSearch();
                              }
                            }}
                            placeholder="Search for Name & Description."
                          />
                          <div
                            className="btn btn-primary ms-3"
                            onClick={() => handleSearch()}
                          >
                            <IoMdSearch size={25} />
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                          {isAdmin(userInfo) && !projectType && (
                            // <select
                            //   className="form-select"
                            //   aria-label="Default select example"
                            //   value={userFilter}
                            //   onChange={handleUserChange}
                            // >
                            //   <option disabled>Select User</option>
                            //   <option selected="" value={""}>
                            //     All
                            //   </option>

                            //   {userList.map((item) => (
                            //     <option value={item}>{item}</option>
                            //   ))}
                            // </select>
                            <Select
                              // className="form-select"
                              styles={customStyles}
                              value={userFilter ? { label: userFilter, value: userFilter } : { label: "All", value: "All" }}

                              placeholder="Select user."
                              onChange={handleUserChange}

                              options={[{ label: "Select a user", value: "Select a user", isDisabled: true }, { label: "All", value: "All" }, ...convertToUserOptions(userList)]}
                            />
                          )}
                        </div>
                        <div className="col-lg-2 col-md-4  mt-3 mt-md-3">
                          {!projectType && (
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={isStatusFilter}
                              onChange={handleIsStatusChange}
                            >
                              <option disabled>Select Status</option>
                              <option selected="" value={""}>
                                All
                              </option>
                              {taskStatusFilter.map((item) => (
                                <option value={item.id}>{item.value}</option>
                              ))}
                            </select>
                          )}
                        </div>
                      </div>
                    </>
                  </div>
                  {!isLoading ? (
                    <>
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          {currentItems.length > 0 ? (
                            <table className="table text-nowrap mb-0 responsive-table main-table table-centered table-hover">
                              <thead className="table-light">
                                <tr>
                                  <th className=" pe-0  ">
                                    {" "}
                                    Project
                                    <br />
                                    Description
                                  </th>
                                  <th className="">
                                    Actual End
                                    <br /> Actual Start
                                  </th>
                                  <th className="">
                                    Planned End
                                    <br /> Planned Start
                                  </th>
                                  {/* <th>Approx Days</th> */}
                                  <th>
                                    By <br />
                                    To
                                  </th>
                                  <th>Status</th>
                                  <th>Info</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {currentItems.map((project, index) => (
                                  <tr
                                    id={`user-${index}`}
                                    className={`${parseInt(projectId) === project?.ID
                                      ? "table-primary"
                                      : ""
                                      }`}
                                  >
                                    <td
                                      className="name"

                                    >
                                      <div className="d-flex flex-column">
                                        <strong
                                          className="cursor-pointer truncate"
                                          onClick={() => editTask(project)}
                                        >
                                          {project?.Name}(
                                          {formatTimeDuration(project?.Duration)})
                                        </strong>
                                        {/* <br /> */}
                                        <div className="truncate">
                                          <small>{project?.Dscr}</small>
                                        </div>
                                      </div>
                                    </td>

                                    <td
                                      data-label1="Actual End"
                                      data-label2="Actual Start"

                                      style={{
                                        width: "205px",
                                      }}
                                    >
                                      <div className="d-flex flex-column">

                                        <div
                                          className={`bg-light text-dark  ps-2 pe-2 rounded text-center mb-1 `}
                                        >
                                          {
                                            formatDateTimetoAmPm(project?.ActualEndDtTm)


                                          }
                                        </div>
                                        {/* <br /> */}
                                        <div
                                          className={`bg-light text-dark  ps-2 pe-2 rounded text-center`}
                                        >
                                          {
                                            formatDateTimetoAmPm(project?.ActualStDtTm)
                                          }
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      data-label1="Planned End"
                                      data-label2="Planned Start"

                                      style={{
                                        width: "205px",
                                      }}
                                    >
                                      <div className="d-flex flex-column">

                                        <div
                                          className={getClassNamesOfEndDate(
                                            project.ActualEndDtTm,
                                            project.EndDtTm,
                                            project.Status.text
                                          )}
                                        >
                                          {
                                            formatDateTimetoAmPm(project?.EndDtTm)
                                          }
                                        </div>
                                        <div
                                          className={getClassNamesOfStartDate(
                                            project.ActualStDtTm,
                                            project.StartDtTm,
                                            project.Status.text
                                          )}
                                        >
                                          {
                                            formatDateTimetoAmPm(project?.StartDtTm)
                                          }
                                        </div>
                                      </div>
                                    </td>

                                    <td
                                      data-label1="By"
                                      data-label2="To"

                                      // className="truncate"
                                      style={{
                                        width: "120px",
                                        textWrap: "wrap",
                                        // textAlign: "center",
                                      }}
                                    >
                                      <div className="d-flex flex-column">

                                        <div className="truncate-1 mb-2">
                                          <strong>{project?.AllocBy}</strong>
                                        </div>
                                        {/* <br /> */}
                                        <div className="truncate-1">
                                          {project?.ProjLead}
                                        </div>
                                      </div>
                                    </td>
                                    <td
                                      data-label1="Status"


                                      style={{
                                        width: "120px",
                                        textWrap: "wrap",
                                        // textAlign: "center",
                                      }}
                                    >
                                      <div
                                        className={getClassNamesOfStatus(
                                          project.Status.text
                                        )}
                                      >
                                        {project?.Status?.text}
                                      </div>
                                    </td>
                                    <td
                                      data-label1="Info"
                                      style={{
                                        width: "120px",
                                        textWrap: "wrap",
                                        // textAlign: "center",
                                      }}
                                    >

                                      <div className="d-flex fs-3">
                                        {project?.ProjTranID && "P"}
                                        {project?.tasks_list?.length > 0 && "T"}
                                        {project?.Priority === 1 && ""}
                                        <div className="text-warning fw-bold">
                                          {project?.Priority === 2 && "!"}
                                        </div>
                                        <div className="text-danger fw-bold">
                                          {project?.Priority === 3 && "!"}
                                        </div>
                                        {parseInt(project?.attachments_no) >
                                          0 && (
                                            <div className="ms-1 position-relative d-flex justify-content-center align-items-center">
                                              <CgAttachment
                                                size={18}
                                                style={{ fill: "#624bff" }}
                                              />
                                              {/* <div className="position-absolute attechmenst-count" >{task?.attachments_no}</div> */}
                                            </div>
                                          )}
                                        {project?.notifications?.total > 0 && (
                                          <div className="rounded-circl notification-count nav-item  d-flex">
                                            <div className="ms-1 position-relative d-flex justify-content-center align-items-center">
                                              <MdNotificationsNone size={22} />
                                              {/* <div className="position-absolute attechmenst-count" >{task?.attachments_no}</div> */}
                                            </div>
                                            <div
                                              className="notification-count d-flex justify-content-center"
                                              style={{
                                                top: "-5px",
                                                right: "-10px",
                                              }}
                                            >
                                              {project?.notifications?.unread}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    <td
                                      data-label1="Action"
                                      style={{
                                        width: "120px",
                                        textWrap: "wrap",
                                        // textAlign: "center",
                                      }}
                                    >
                                      <div className="d-flex">

                                        <div
                                          className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                          data-template="editOne"
                                          onClick={() => editTask(project)}
                                        >
                                          <FaRegEdit
                                            size={20}
                                            style={{ fill: "#624bff" }}
                                          />
                                          <div id="editOne" className="d-none">
                                            <span>Edit</span>
                                          </div>
                                        </div>
                                        {userInfo.user_code === project.AllocBy &&
                                          project.Status.text === "Pending" && (
                                            <div
                                              className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                              data-template="trashOne"
                                              onClick={() => {
                                                handleConfirmationShow();
                                                removeSelection();
                                                setFunHandler({
                                                  fun: removeProject,
                                                  id: project.ID,
                                                  title: "delete project",
                                                });
                                              }}
                                            >
                                              <MdOutlineDelete
                                                size={22}
                                                style={{ fill: "#d2042dc7" }}
                                              />
                                              <div
                                                id="trashOne"
                                                className="d-none"
                                              // onClick={() => deleteTask(task.ID)}
                                              >
                                                <span>Delete</span>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div className={` fs-3 ${isFilterOpen ? "show-margin" : "hidden-margin"}`}>
                              <strong>No records found.!</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      {filteredData.length > 0 && (
                        <div className="card-footer d-md-flex justify-content-between align-items-center">
                          <span>
                            Showing{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) -
                              Number(sysConfig["Rows in MultiLine List"]) +
                              1}{" "}
                            to{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) >=
                              filteredData.length
                              ? filteredData.length
                              : currentPage *
                              Number(
                                sysConfig["Rows in MultiLine List"]
                              )}{" "}
                            of {filteredData.length} entries
                          </span>
                          <nav className="mt-2 mt-md-0">
                            <ul className="pagination mb-0 ">
                              <li
                                className="page-item "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    handlePageChange(currentPage - 1);
                                    removeSelection();
                                  }
                                }}
                              >
                                <div
                                  className={`page-link ${currentPage === 1 ? "disabled" : ""
                                    } `}
                                >
                                  Previous
                                </div>
                              </li>
                              {Array(totalPages ? totalPages : 0)
                                .fill()
                                .map((item, index) => (
                                  <li
                                    style={{ cursor: "pointer" }}
                                    className={`${currentPage === index + 1
                                      ? "page-item active"
                                      : "page-item"
                                      } ${currentPage + 2 >= index + 1 &&
                                        index + 1 > currentPage - 2
                                        ? // currentPage - 2 < index + 1
                                        "d-block"
                                        : "d-none"
                                      }`}
                                    onClick={() => {
                                      handlePageChange(index + 1);
                                      removeSelection();
                                    }}
                                  >
                                    <div className="page-link">{index + 1}</div>
                                  </li>
                                ))}

                              <li className="page-item">
                                <div
                                  style={{ cursor: "pointer" }}
                                  className={`page-link ${totalPages === currentPage ? "disabled" : ""
                                    } `}
                                  onClick={() => {
                                    if (totalPages > currentPage) {
                                      removeSelection();
                                      handlePageChange(currentPage + 1);
                                    }
                                  }}
                                >
                                  Next
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>Fetching records..</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default Project;
